import { BaseComponent } from '../base-component/base-component';
import { PaymentOrderItemData } from '../order-confirmation/order-completion.interface';
import { ProductCardData } from '../product-card/product-card-display';
import { TemplateResult, html } from 'lit';
import { calculateDurationDigitalProduct, isProfessional } from '../../common/utils/product-util';
import { customElement, property } from 'lit/decorators.js';

@customElement('mhecomm-subscription-access-through')
export class SubscriptionAccessThrough extends BaseComponent {
  /**
   * A start date to use as a fallback.
   */
  @property({type: String})
  fallBackDate = '';

  /**
   * A JSON String in the format of a product object that contains duration details.
   */
  @property({type: Object})
  product?: PaymentOrderItemData | ProductCardData;

  renderComp(): TemplateResult {
    if (
      !isProfessional(this.product?.businessUnit ?? '')
      || !this.product?.duration
      || !this.product?.durationPeriod) {
      return html``;
    }

    const createdDate = (this.product?.isFreeTrial && this.product?.freeTrialEndDate)
      ? Number(this.product.freeTrialEndDate) * 1000
      : this.fallBackDate;

    return html`
      <span class="fw-bold">Access Through: </span>
      <span data-automation-id=${this.getAutomationId()}>
      ${calculateDurationDigitalProduct(this.product.duration, this.product.durationPeriod, createdDate)
        .toLocaleDateString("en-US")}
      </span>
    `;
  }

  /**
   * Returns the automation id for the subscription length.
   */
  getAutomationId(): string {
    const prefix = 'access-through';

    if (this.product && 'isbn10' in this.product) {
      return `${prefix}-${this.product.isbn10}`;
    }

    if (this.product && 'isbn' in this.product) {
      return `${prefix}-${this.product.isbn}`;
    }

    return prefix;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-subscription-access-through': SubscriptionAccessThrough;
  }
}
